module.exports = __webpack_public_path__ + "img/50.5210b136.png";